namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_widget_float_table_relation_atom, {
		width: '100%',
		flexWrap: 'wrap',
		Picker: {
			marginLeft: 'auto',
			Trigger: { padding: $mol_gap.text, justify: { content: 'center' } },
		},
		Item: { '[selected]': { true: { color: $mol_theme.current } } },
	} )

	$mol_style_define( $shm_hitalama_map_widget_float_table_relation_list, {
		width: '100%',
		maxWidth: '100%',
		minWidth: 0,
		flex: { wrap: 'wrap' },
		Create: { '[selected]': { true: { color: $mol_theme.current } } },
		Item: {
			maxWidth: '100%',
			minWidth: 0,
			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
			flex: { shrink: 1 },
			'[selected]': { true: { color: $mol_theme.current } },
		},
	} )

}
